export class LoginDto {

  constructor(public username: string, public password: string) {
  }

}
